import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const adminApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('brandos_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('brandos_admin_token');
      if (typeof window !== 'undefined' && !window.location.pathname.endsWith('/skyportal')) {
        window.location.href = '/skyportal';
      }
    }
    return Promise.reject(error);
  }
);

export const adminAPI = {
  getSecurityQuestion: () => adminApi.get('/admin/security-question'),
  login: (data) => adminApi.post('/admin/login', data),
  overview: () => adminApi.get('/admin/overview'),
  listUsers: (params) => adminApi.get('/admin/users', { params }),
  getUser: (id) => adminApi.get(`/admin/users/${id}`),
  updateUser: (id, data) => adminApi.put(`/admin/users/${id}`, data),
  deleteUser: (id) => adminApi.delete(`/admin/users/${id}`),
  reportsQueue: () => adminApi.get('/admin/reports/queue'),
  saveReport: (data) => adminApi.post('/admin/reports/save', data),
  sendReport: (data) => adminApi.post('/admin/reports/send', data),
  listAffiliates: (params) => adminApi.get('/admin/affiliates', { params }),
  createAffiliate: (data) => adminApi.post('/admin/affiliates', data),
  updateAffiliate: (id, data) => adminApi.put(`/admin/affiliates/${id}`, data),
  deleteAffiliate: (id) => adminApi.delete(`/admin/affiliates/${id}`),
  analytics: (days = 30) => adminApi.get('/admin/analytics', { params: { days } }),
  exportUsers: () => adminApi.get('/admin/analytics/export'),
};

export default adminApi;
